import {numberFormatter} from './';

export default (amount: any, decimals = 2, showDecimals = -1, space = true) => {
  if (amount === null || amount === undefined || amount === '') {
    return '';
  }

  // \u00a0 is non breaking space
  return `${numberFormatter(amount, decimals, showDecimals, '', '')}${space ? '\u00a0' : ''}%`;
};
